const planName = {
	health_plan: "Health Plan",
	clinic_card: "Clinic Card",
	group_short_term_disability: "Group Short Term Disability",
	group_long_term_disability_class1: "Group Long Term Disability(Class 1)",
	group_long_term_disability_class2: "Group Long Term Disability(Class 2)",
	helping_our_own: "Helping Our Own",
	// brokeshire_brothers_inc_KSOP: "KSOP",
	group_life_insurance: "Group Life Insurance",
	christmas_club_election_form: "Christmas Club Election",
	KSOP: "KSOP"
};

export const PLAN_NAMES = planName;

const panhandleCorePlanName = {
	health_plan: "Health Plan",
	dental_plan: "Dental Plan",
	vision_plan: "Vision Plan"
};

export const PANHANDLE_CORE_PLAN_NAMES = panhandleCorePlanName;

const planNameIci = {
	ici_health_plan: "Health Plan",
	ici_flex_med: "Flex Med",
	ici_flex_care: "Flex Care",
	ici_group_long_term_disability: "Group Long Term Disability",
	ici_group_life_insurance_free: "Group Life Insurance(Free)",
	ici_group_life_insurance_optional: "Group Life Insurance(Optional)"
};
export const PLAN_NAMES_ICI = planNameIci;

const planNamePL = {
	pl_health_plan: "Health Plan"
};
export const PLAN_NAMES_PL = planNamePL;

export const BBI_PLAN_NAMES_FOR_ALL_EMPLOYEE_CLASS = ["Helping Our Own", "Christmas Club Election", "KSOP"];

export const BBI_PLAN_NAMES = [
	"Health Plan",
	"Clinic Card",
	"Group Short Term Disability",
	"Group Long Term Disability(Class 1)",
	"Group Long Term Disability(Class 2)",
	"Helping Our Own",
	"Group Life Insurance",
	"Christmas Club Election",
	"KSOP"
];

export const VEB_BBI_PLAN_NAMES = [
	"Cancer",
	"Accident",
	"Whole life",
	"Short Term Disability",
	"Critical Illness",
	"Hospital Indemnity",
	"Group Life Indemnity",
	"Family Protection",
	"Doc and Rx",
	"Vision",
	"Dental"
];

export const ICI_PLAN_NAMES = [
	"Health Plan",
	"Flex Med",
	"Flex Care",
	"Group Long Term Disability",
	"Group Life Insurance(Free)",
	"Group Life Insurance(Optional)"
];

export const PL_PLAN_NAMES = ["Health Plan"];

export const PFB_PLAN_NAMES = ["Health Plan", "Dental Plan", "Vision Plan"];

export const VEB_PLAN_NAMES = {
	cancer: "Cancer",
	accident: "Accident",
	whole_life: "Whole life",
	short_term_disability: "Short Term Disability",
	critical_illness: "Critical Illness",
	hospital_indemnity: "Hospital Indemnity",
	group_life_indemnity: "Group Life Indemnity",
	family_protection: "Family Protection",
	doc_and_rx: "Doc and Rx",
	vision: "Vision",
	dental: "Dental"
};

export const GROUP_PLAN_NAMES = {
	all: "All",
	health_plan: "Health Plan",
	clinic_card: "Clinic Card",
	group_short_term_disability: "Group Short Term Disability",
	group_long_term_disability_class1: "Group Long Term Disability(Class 1)",
	group_long_term_disability_class2: "Group Long Term Disability(Class 2)",
	helping_our_own: "Helping Our Own",
	group_life_insurance: "Group Life Insurance",
	christmas_club_election_form: "Christmas Club Election",
	KSOP: "KSOP"
};

export const PROGRESSIVE_LABORATORIES_PLAN_NAMES = {
	all: "All",
	health_plan: "Health Plan"
};

export const PANHANDLE_FIRST_BANK_CORE_PLAN_NAMES = {
	all: "All",
	health_plan: "Health Plan(Copay Health Plan)",
	health_plan_2: "Health Plan(High Deductible Health Plan)",
	dental_plan: "Dental Plan",
	vision_plan: "Vision Plan"
};

export const MedMutualPlans = [
	"Cancer",
	"Whole life",
	"Short Term Disability",
	"Critical Illness",
	"Hospital Indemnity",
	"Accident"
];

export const BeazleyPlan = ["Group Life Indemnity"];

export const FiveStarPlan = ["Family Protection"];

export const DocAndRxPlan = ["Doc and Rx"];

export const BeamPlan = ["Vision"];

export const MaxCarePlan = ["Dental"];

export const VEBCarriers = ["MedMutual", "Beazley", "Five Star", "Afmax", "Beam", "MaxCare", "Globe Life"];
